import dayjs from "dayjs";

export function formatAccountingMoney(
  value: number,
  currency: string
): string {
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency || "GBP",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    return `${value.toFixed(2)} ${currency}`;
  }
}

export function formatAccountingDate(epochMs: number): string {
  if (!epochMs) return "—";
  return dayjs(epochMs).format("DD MMM YYYY");
}

export function formatAccountingDateTime(epochMs: number): string {
  if (!epochMs) return "—";
  return dayjs(epochMs).format("DD MMM YYYY, HH:mm");
}

const EXPENSE_TYPE_LABELS: Record<string, string> = {
  PAYROLL: "Payroll",
  SOFTWARE: "Software",
  PDQ_CHARGES: "PDQ charges",
  SUPPLIER_BILL: "Supplier bill",
  OTHER: "Other",
};

export function formatExpenseTypeLabel(type: string | undefined): string {
  if (!type) return "—";
  return EXPENSE_TYPE_LABELS[type] ?? type;
}
